import { VERSIONE_SCONOSCIUTA } from "../../shared/build-version";

/**
 * Versione scritta dentro il pacchetto al momento della compilazione.
 * Il valore lo sostituisce Vite (vedi `define` in vite.config.ts): qui resta
 * la risposta onesta per gli ambienti dove quella sostituzione non avviene.
 */
declare const __MANUTIO_VERSIONE__: string | undefined;

export function versioneApp() {
  if (typeof __MANUTIO_VERSIONE__ !== "string") return VERSIONE_SCONOSCIUTA;
  return __MANUTIO_VERSIONE__.trim() || VERSIONE_SCONOSCIUTA;
}
